import * as React from 'react'
import { AppContent, Layout, Well } from '@pushly/aqe/lib/components'
import { classnames } from '@halo/_utils/classnames'
import '@halo/style'
import '@halo/portals/pre-auth/style/login.scss'
import './styles/maintenance-503.scss'

export class Maintenance503 extends React.Component<any, any> {
    public render() {
        return (
            <div
                className={classnames('wrapper', {
                    ['authenticated']: false,
                    ['mode-503']: true,
                    ['maintenance-mode']: true,
                })}
            >
                <div className={classnames('portal', 'pre-auth')}>
                    <Layout>
                        <AppContent>
                            <div className={classnames('page', 'login')}>
                                <div className={classnames('page-wrapper')}>
                                    <div className={classnames('login-form')}>
                                        <div className={classnames('login-form-wrapper')}>
                                            <Well mode="ghost" hideHeader={true} hideFooter={true}>
                                                <div className="login-logo" />

                                                <div className="mode-503-content">
                                                    <div className="logo" />

                                                    <div className="header">
                                                        Sorry, we're currently down for scheduled maintenance.
                                                    </div>

                                                    <div className="sub-header">We'll be back up shortly.</div>
                                                </div>
                                            </Well>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </AppContent>
                    </Layout>
                </div>
            </div>
        )
    }
}
